import React, { MutableRefObject, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnClickOutside } from 'utils/hooks/useOnClickOutside';
import SkeletonSpinner from 'components/skeleton-spinner/SkeletonSpinner';
import './ReferenceDropdownOrder.scss';
import { IImportFileNew, IParts } from 'interfaces/price';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import CURRENCY from 'utils/constants/currency';

type Props = {
  refData: IImportFileNew[];
  setIsOpen: (isOpen: boolean) => void;
  loading: boolean;
  setSelectedItem: (item: IParts) => void;

};


const ReferenceDropdownOrder: React.FC<Props> = (props) => {
  const referenceDropdownRef = useRef() as MutableRefObject<HTMLDivElement>;
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.userData.user);


  useOnClickOutside(referenceDropdownRef, () => props.setIsOpen(false));


  return (
    <div ref={referenceDropdownRef} className="new-ref-dropdown-order">
      <div className="ref-dropdown-header">
        <div className="ref-dropdown-title">{t('_search_result')}</div>
      </div>
      <div className="ref-search-result-content">
        {props.loading ? (
          <SkeletonSpinner />
        ) : (
          <React.Fragment>
            {props.refData?.length ? (
              props.refData?.map((item, index) => {
                return item.parts?.map((child, i) => {
                  return (
                    <li key={index + i} className="suggestion-list-item">
                      <div className="suggestion-item-title" onClick={() => { props.setSelectedItem(child); }}>
                        <div>{child.reference} </div>  <div>{child.name}</div>  <div>{Number(child.price).toFixed(2)} {CURRENCY[user!.currency]} </div>

                      </div>


                    </li>
                  );
                });
              })
            ) : (
              <div className="no-data">{t('_no_data').toLocaleUpperCase()}</div>
            )}
            { }
          </React.Fragment>
        )}
      </div>
    </div >
  );
};

ReferenceDropdownOrder.displayName = 'ReferenceDropdownOrder';

export default ReferenceDropdownOrder;
